import {Lamelarea} from './lamelarea.interface';
import {LamellaSet} from "./lamel/lamella-set.class";
import {GeneralProfile} from "./profiles/general-profile/general-profile";
import {FrameProfile} from "./profiles/frame-profile/frame-profile";
import {MountingProfile} from "./profiles/mounting-profile/mounting-profile";
import {AssemblySpacingInput} from "../../../assembly-configurator/models/spacing-input";
import {AssemblyFrameInput} from "../../../assembly-configurator/models/assembly-frame-input";


export class LamelareaImpl implements Lamelarea {
    constructor(
        public id: string,
        public order: number,
        public name: string,
        public groupId: string,
        public lamellaSets: LamellaSet[],
        public lamellaSetType: number,
        public orientation: 'horizontal' | 'vertical',

        public dimensionsPristine: boolean,
        public width: number,
        public height: number,
        public demoSize : boolean,

        public coverProfile : GeneralProfile | null,
        public mountingProfile : MountingProfile,
        public frameProfile : FrameProfile | null,

        public syncMountingProfile : boolean,
        public syncCoverProfile : boolean,

        public automaticFrames: boolean,
        public assemblyAutoConfig?: any,
        public assemblyArray?: Array<AssemblySpacingInput|AssemblyFrameInput>,
        public framePositions?: Array<{position: number, reinforced: boolean}>
    ) {}
}